import React from 'react';
import ReactDOM from 'react-dom/client';
import '/src/styles/index.css';
import App from './App';
import { Provider, ErrorBoundary } from '@rollbar/react'
import { BrowserRouter } from 'react-router-dom';
import Rollbar from 'rollbar';
const rollbarConfig = {
  accessToken: '6dac23a10b4d4eb797cb71bd64e0d80f',
  environment: 'testenv',
  captureUncaught: true, 
  captureUnhandledRejections: true
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider config={rollbarConfig}>
      <ErrorBoundary> 
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
